export const DISPLAY_NOTIFICATION = 'DISPLAY_NOTIFICATION';
export const CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION';

export const Position = {
  top_left: 'top-left',
  top_right: 'top-right',
  top_center: 'top-center',
  bottom_left: 'bottom-left',
  bottom_right: 'bottom-right',
  bottom_center: 'bottom-center',
};

export const NotificationType = {
  danger: 'danger',
  warning: 'warning',
  info: 'info',
  success: 'success',
};

export const defaultState = {
  listOfNotifications: [],
  maxNumberOfNotifications: 5,
  showNotifications: false,
};
